// ui/sxTokens.js
import { alpha } from '@mui/material/styles';

export function useSxTokens(theme) {
  const isDark = theme.palette.mode === 'dark';
  const surface = isDark ? alpha('#fff', 0.06) : alpha('#0b1220', 0.035);
  const surface2 = isDark ? alpha('#fff', 0.04) : alpha('#0b1220', 0.025);
  const border = isDark ? alpha('#fff', 0.12) : alpha('#0b1220', 0.1);
  const ring = `0 0 0 3px ${alpha(theme.palette.primary.main, 0.18)}`;

  const card = {
    border: `1px solid ${border}`,
    borderRadius: '16px',
    background: surface,
    p: 1.25,
    display: 'grid',
    gap: 1,
  };

  const select = {
    background: surface,
    borderRadius: '14px',
    '& .MuiOutlinedInput-notchedOutline': { border: `1px solid ${border} !important` },
    '&.Mui-focused': { boxShadow: ring },
  };

  const input = {
    '& .MuiOutlinedInput-root': {
      borderRadius: '14px',
      background: surface2,
    },
  };

  const pillBtn = {
    borderRadius: '14px',
    textTransform: 'none',
    fontWeight: 900,
  };

  return { isDark, surface, border, ring, card, select, input, pillBtn };
}
